import { Module } from "vuex"
import { BaseState } from "./index"
import api from "@/services/api"

export interface FeaturesState {
	opsZendeskHelpWidgetEnabled: Boolean
	opsZendeskHelpWidgetInitialized: Boolean
}

export const state: FeaturesState = {
	opsZendeskHelpWidgetEnabled: false,
	opsZendeskHelpWidgetInitialized: false
}

export const features: Module<FeaturesState, BaseState> = {
	namespaced: true,
	state,
	getters: {
		getOpsZendeskHelpWidgetEnabled: state => state.opsZendeskHelpWidgetEnabled,
		getOpsZendeskHelpWidgetInitialized: state => state.opsZendeskHelpWidgetInitialized
	},
	mutations: {
		setOpsZendeskHelpWidgetEnabled: (state: FeaturesState, widgetEnabled: boolean) => {
			state.opsZendeskHelpWidgetEnabled = widgetEnabled
			state.opsZendeskHelpWidgetInitialized = true
		}
	},
	actions: {
		async getOpsZendeskHelpWidgetEnabledSetting ({ commit, getters }) {
			await api.getOpsZendeskHelpWidgetEnabledSetting().then((widgetEnabled) => {
				commit("setOpsZendeskHelpWidgetEnabled", widgetEnabled)
			})
		}
	}
}
